import * as Yup from 'yup';

const CancelPaymentValidator = () => Yup.object().shape({
  refund_date: Yup.string(),
});

export default CancelPaymentValidator;
